import { gql } from "@apollo/client";

export const GET_INFO_DIRECCION_RI = gql`
    query GetInfoDireccionRIByIdDatosGeneralesRI ($idDatosGenerales: Int!) {
        infoDireccionRIByIdDatosGeneralesRI (idDatosGenerales: $idDatosGenerales) {
            apto,
            direccion,
            localidad,
            provincia,
            zonaDesfavorable
        }
    }
`;